import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useMappingTypeReducer = () => useSelector((state: ApplicationState) => state.mappingType);
